
import React, { Component } from 'react';
import BodyClassName from 'react-body-classname';
import SummaryBlock from '../components/SummaryBlock/SummaryBlock';
import LayoutFullWidth from './LayoutFullWidth';
import LayoutStandardWidth from './LayoutStandardWidth';
import SummaryBlockLoader from '../components/SummaryBlock/SummaryBlockLoader';
import CONSTANTS from '../constants';
//import SummaryBlockMobile from '../components/SummaryBlock/SummaryBlockMobile';
import SummaryBlockMobile2 from '../components/SummaryBlock/mobile/SummaryBlockMobile2';

class LayoutWithRecap extends Component {
	constructor(props) {
		super(props);
		this.state = {
			'pageLoaded': false,
		};
	}
	componentDidMount() {
		window.setTimeout(function () { this.setState({ pageLoaded: true }) }.bind(this), 2000);
	}
	render() {
		return (
			<React.Fragment>
				{window.isMobile() == 'desktop' && <LayoutStandardWidth>
					{this.state.pageLoaded && <SummaryBlock />}
					{!this.state.pageLoaded && <SummaryBlockLoader />}
				</LayoutStandardWidth>}
				{window.isMobile() == 'mobile' && CONSTANTS.SITE_INFO.BRAND_CODE === "C" && <SummaryBlockMobile2/>}
				<LayoutFullWidth>
					{this.props.children}
				</LayoutFullWidth>
			</React.Fragment>
		);
	}
}

export default LayoutWithRecap;